import classNames from 'classnames';
import React, { useEffect } from 'react';
import { iframeScrollToTop } from '../../../common/utils/Utils';
import { config } from '../../common';

export interface BreadcrumbItem {
    to: string;
    label: string;
}

interface TopNavProps {
    items: BreadcrumbItem[];
}

const TopNav: React.FC<TopNavProps> = (props) => {
    useEffect(() => {
        iframeScrollToTop();
    }, []);

    // 2023-10: Removed tracy as per BMW's request
    // Utils.CallTracyPage();

    return (
        <div className={classNames(['grid-x', 'grid-margin-x', 'my-bmw'])}>
            <div className={classNames(['cell', 'small-6'])}>

                <nav className={classNames(['my-bmw-nav-left', 'align-self-middle', 'middle', 'float-left'])} role="navigation">
                    <ul className={'breadcrumbs'}>
                        {props.items.map(({ to, label }, i) => (
                            <li key={to}>
                                <a href={to}>
                                    {label}
                                </a>
                                <i className={classNames(['fa'])} />
                            </li>

                        ))}
                    </ul>
                </nav>

            </div>
            <div className={classNames(['cell', 'small-6'])}>
                <nav className={classNames(['my-bmw-nav-right', 'align-self-middle', 'middle', 'float-right'])} role="navigation">
                    <ul className={'breadcrumbs'}>
                        <li><a href={config.BaseURL} className={'navhome'}><i className={classNames(['fa', 'fa-solid', 'fa-angle-left'])} />Home</a></li>
                    </ul>
                </nav>
            </div>

        </div>

    );
};

export default TopNav;
